let lastTop = 0;

function updateTop() {
  const block1 = document.querySelector('.js-syndicated-tables-header');
  const block2 = document.querySelector('.filter-bar');
  const block3 = document.querySelector('.js-syndicated-tables-row-header');
  const height1 = block1.offsetHeight;
  const height2 = block2.offsetHeight;
  const newTop = height1 + height2;

  if (lastTop !== newTop) {
    block2.style.top = `${height1}px`;
    block3.style.top = `${newTop}px`;
    lastTop = newTop;
  }
}

window.addEventListener('load', updateTop);
window.addEventListener('resize', updateTop);
